module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.8cbe6488.svg";